document.addEventListener('DOMContentLoaded', () => {
	const shipButtons = document.querySelectorAll('.ship-button')
	const shipPopup = document.querySelector('.shippingPopup')
	const shipClose = shipPopup?.querySelector('button.close')

	shipButtons.forEach(btn => {
		btn.addEventListener('click', () => {
			shipPopup.classList.add('open')
		})
	})

	shipClose?.addEventListener('click', () => {
		shipPopup.classList.remove('open')
	})
})
